const Dashboard = () => import('@/views/modules/Dashboard')

const DashboardMoke = () => import('@/views/modules/DashboardBackUp.vue')


const GeneralMyReport = () => import('@/views/modules/general/MyReport')
const GeneralMyReportItem = () => import('@/views/modules/general/MyReportItem')
const GeneralMyUserHistory = () => import('@/views/modules/general/MyUserHistory')
const GeneralMyUserChangePassword = () => import('@/views/modules/general/MyUserChangePassword')
const GeneralLabel = () => import('@/views/modules/general/Label')
const GeneralLabelForm = () => import('@/views/modules/general/LabelForm')

const AdminCompany = () => import('@/views/modules/admin/Company')
const AdminCompanyForm = () => import('@/views/modules/admin/CompanyForm')
const AdminUser = () => import('@/views/modules/admin/User')
const AdminUserForm = () => import('@/views/modules/admin/UserForm')
const AdminDepartment = () => import('@/views/modules/admin/Department')
const AdminDepartmentForm = () => import('@/views/modules/admin/DepartmentForm')
const AdminGroupUser = () => import('@/views/modules/admin/GroupUser')
const AdminGroupUserForm = () => import('@/views/modules/admin/GroupUserForm')
const AdminProfile = () => import('@/views/modules/admin/Profile')
const AdminProfileForm = () => import('@/views/modules/admin/ProfileForm')
const AdminPrinter = () => import('@/views/modules/admin/Printer')
const AdminPrinterForm = () => import('@/views/modules/admin/PrinterForm')
const AdminAccessControl = () => import('@/views/modules/admin/AccessControl')
const AdminAccessControlForm = () => import('@/views/modules/admin/AccessControlForm')
const AdminSettingParam = () => import('@/views/modules/admin/Setting/SettingParam')
const AdminSettingParamForm = () => import('@/views/modules/admin/Setting/SettingParamForm')
const AdminSetting = () => import('@/views/modules/admin/Setting/Setting')


const ProductProduct = () => import('@/views/modules/product/Product')
const ProductProductForm = () => import('@/views/modules/product/ProductForm')
const ProductFamilyProduct = () => import('@/views/modules/product/FamilyProduct')
const ProductFamilyProductForm = () => import('@/views/modules/product/FamilyProductForm')
const ProductModel = () => import('@/views/modules/product/Model')
const ProductModelForm = () => import('@/views/modules/product/ModelForm')
const ProductCharacteristics = () => import('@/views/modules/product/Characteristics')
const ProductCharacteristicsForm = () => import('@/views/modules/product/CharacteristicsForm')
const ProductBookmarks = () => import('@/views/modules/product/Bookmarks')
const ProductBookmarksForm = () => import('@/views/modules/product/BookmarksForm')
const ProductMarketCode = () => import('@/views/modules/product/MarketCode')
const ProductMarketCodeForm = () => import('@/views/modules/product/MarketCodeForm')
const ProductUnit = () => import('@/views/modules/product/Unit')
const ProductUnitForm = () => import('@/views/modules/product/UnitForm')
const ProductRawMaterial = () => import('@/views/modules/product/RawMaterial')
const ProductRawMaterialForm = () => import('@/views/modules/product/RawMaterialForm')
const ProductTypeRawMaterial = () => import('@/views/modules/product/TypeRawMaterial')
const ProductTypeRawMaterialForm = () => import('@/views/modules/product/TypeRawMaterialForm')
const ProductComponent = () => import('@/views/modules/product/Component')
const ProductComponentForm = () => import('@/views/modules/product/ComponentForm')
const ProductTypeComponent = () => import('@/views/modules/product/TypeComponent')
const ProductTypeComponentForm = () => import('@/views/modules/product/TypeComponentForm')
const ProductCompound = () => import('@/views/modules/product/Compound')
const ProductCompoundForm = () => import('@/views/modules/product/CompoundForm')
const ProductTypeCompound = () => import('@/views/modules/product/TypeCompound')
const ProductTypeCompoundForm = () => import('@/views/modules/product/TypeCompoundForm')
const ProductTypeMaterial = () => import('@/views/modules/product/TypeMaterial')
const ProductTypeMaterialForm = () => import('@/views/modules/product/TypeMaterialForm')
const ProductTypeFeature = () => import('@/views/modules/product/TypeFeature')
const ProductTypeFeatureForm = () => import('@/views/modules/product/TypeFeatureForm')
const ProductFeature = () => import('@/views/modules/product/Feature')
const ProductFeatureForm = () => import('@/views/modules/product/FeatureForm')
const ProductComplement = () => import('@/views/modules/product/Complement')
const ProductComplementForm = () => import('@/views/modules/product/ComplementForm')
const ProductTypeBuildingMaterial = () => import('@/views/modules/product/TypeBuildingMaterial')
const ProductTypeBuildingMaterialForm = () => import('@/views/modules/product/TypeBuildingMaterialForm')
const ProductTypeEquipment = () => import('@/views/modules/product/TypeEquipment')
const ProductTypeEquipmentForm = () => import('@/views/modules/product/TypeEquipmentForm')
const ProductMaterial = () => import('@/views/modules/product/Material')
const ProductMaterialForm = () => import('@/views/modules/product/MaterialForm')
const ProductTolerance = () => import('@/views/modules/product/Tolerance')
const ProductToleranceForm = () => import('@/views/modules/product/ToleranceForm')
const ProductSettingParam = () => import('@/views/modules/product/Setting/SettingParam')
const ProductSettingParamForm = () => import('@/views/modules/product/Setting/SettingParamForm')
const ProductSetting = () => import('@/views/modules/product/Setting/Setting')
const ProductReport = () => import('@/views/modules/product/Report')

const CustomerCustomer = () => import('@/views/modules/customer/Customer')
const CustomerCustomerForm = () => import('@/views/modules/customer/CustomerForm')
const CustomerGroupCustomer = () => import('@/views/modules/customer/GroupCustomer')
const CustomerGroupCustomerForm = () => import('@/views/modules/customer/GroupCustomerForm')
const CustomerTypeProfile = () => import('@/views/modules/customer/TypeProfile')
const CustomerTypeProfileForm = () => import('@/views/modules/customer/TypeProfileForm')
const CustomerTypeOrigin = () => import('@/views/modules/customer/TypeOrigin')
const CustomerTypeOriginForm = () => import('@/views/modules/customer/TypeOriginForm')

const CustomerSettingParam = () => import('@/views/modules/customer/Setting/SettingParam')
const CustomerSettingParamForm = () => import('@/views/modules/customer/Setting/SettingParamForm')
const CustomerSetting = () => import('@/views/modules/customer/Setting/Setting')
const CustomerReport = () => import('@/views/modules/customer/Report')

const StockProduct = () => import('@/views/modules/stock/StockProduct/StockProduct')
const StockProductManualForm = () => import('@/views/modules/stock/StockProduct/StockProductManualForm')
const StockProductInOut = () => import('@/views/modules/stock/StockProduct/StockProductInOut')
const StockPlaceProduct = () => import('@/views/modules/stock/StockPlaceProduct')
const StockPlaceProductForm = () => import('@/views/modules/stock/StockPlaceProductForm')
const StockPlaceMold = () => import('@/views/modules/stock/StockPlaceMold')
const StockPlaceMoldForm = () => import('@/views/modules/stock/StockPlaceMoldForm')
const StockTypeStatusExpedition = () => import('@/views/modules/stock/TypeExpeditionStatus')
const StockTypeStatusExpeditionForm = () => import('@/views/modules/stock/TypeExpeditionStatusForm')
const StockExpeditionOrder = () => import('@/views/modules/stock/ExpeditionOrder')
const StockExpeditionOrderForm = () => import('@/views/modules/stock/ExpeditionOrderForm')
const StockTypeStockManual = () => import('@/views/modules/stock/TypeStockManual')
const StockTypeStockManualForm = () => import('@/views/modules/stock/TypeStockManualForm')
const StockSettingParam = () => import('@/views/modules/stock/Setting/SettingParam')
const StockSettingParamForm = () => import('@/views/modules/stock/Setting/SettingParamForm')
const StockSetting = () => import('@/views/modules/stock/Setting/Setting')
const StockReport = () => import('@/views/modules/stock/Report')

export default [
    {
        path: '/dashboard',
        component: Dashboard,
        name: 'dashboard'
    },
    {
        path: '/dashboard-production',
        component: DashboardMoke,
        name: 'dashboardMoke'
    },
    {
        path: '/general/my-user/history',
        component: GeneralMyUserHistory,
        name: 'my-user-history'
    },

    {
        path: '/general/my-report/:id',
        name: 'my-report-item',
        component: GeneralMyReportItem
    },
    {
        path: '/general/my-report/',
        component: GeneralMyReport,
        name: 'my-report'
    },

    {
        path: '/general/my-user/change-password',
        component: GeneralMyUserChangePassword,
        name: 'my-user-change-password'
    }

    , {
        path: '/general/label/new',
        name: 'general-label-form-new',
        component: GeneralLabelForm
    }, {
        path: '/general/label/view/:id',
        name: 'general-label-form-view',
        component: GeneralLabelForm
    }, {
        path: '/general/label/remove/:id',
        name: 'general-label-form-remove',
        component: GeneralLabelForm
    }, {
        path: '/general/label/:id',
        name: 'general-label-form',
        component: GeneralLabelForm
    }
    , {path: '/general/label', name: 'general-label', component: GeneralLabel}








    , {
        path: '/product/family/new',
        name: 'product-family-form-new',
        component: ProductFamilyProductForm
    }, {
        path: '/product/family/view/:id',
        name: 'product-family-form-view',
        component: ProductFamilyProductForm
    }, {
        path: '/product/family/remove/:id',
        name: 'product-family-form-remove',
        component: ProductFamilyProductForm
    }, {
        path: '/product/family/:id',
        name: 'product-family-form',
        component: ProductFamilyProductForm
    }
    , {path: '/product/family', name: 'product-family', component: ProductFamilyProduct}
    , {
        path: '/product/model/new',
        name: 'product-model-form-new',
        component: ProductModelForm
    }, {
        path: '/product/model/view/:id',
        name: 'product-model-form-view',
        component: ProductModelForm
    }, {
        path: '/product/model/remove/:id',
        name: 'product-model-form-remove',
        component: ProductModelForm
    }, {
        path: '/product/model/:id',
        name: 'product-model-form',
        component: ProductModelForm
    }
    , {path: '/product/model', name: 'product-model', component: ProductModel}

    , {
        path: '/product/characteristics/form/',
        alias: '/product/characteristics/:id',
        name: 'product-characteristics-form',
        component: ProductCharacteristicsForm
    }
    , {
        path: '/product/characteristics',
        name: 'product-characteristics',
        component: ProductCharacteristics
    }
    , {
        path: '/product/bookmarks/form/',
        alias: '/product/bookmarks/:id',
        name: 'product-bookmarks-form',
        component: ProductBookmarksForm
    }
    , {path: '/product/bookmarks', name: 'product-bookmarks', component: ProductBookmarks}

    , {
        path: '/product/market-code/new',
        name: 'product-market-code-form-new',
        component: ProductMarketCodeForm
    }, {
        path: '/product/market-code/view/:id',
        name: 'product-market-code-form-view',
        component: ProductMarketCodeForm
    }, {
        path: '/product/market-code/remove/:id',
        name: 'product-market-code-form-remove',
        component: ProductMarketCodeForm
    }, {
        path: '/product/market-code/:id',
        name: 'product-market-code-form',
        component: ProductMarketCodeForm
    }
    , {path: '/product/market-code', name: 'product-market-code', component: ProductMarketCode}

    , {
        path: '/product/unit/new',
        name: 'product-unit-form-new',
        component: ProductUnitForm
    }, {
        path: '/product/unit/view/:id',
        name: 'product-unit-form-view',
        component: ProductUnitForm
    }, {
        path: '/product/unit/remove/:id',
        name: 'product-unit-form-remove',
        component: ProductUnitForm
    }, {
        path: '/product/unit/:id',
        name: 'product-unit-form',
        component: ProductUnitForm
    }
    , {path: '/product/unit', name: 'product-unit', component: ProductUnit}

    , {
        path: '/product/raw-material/new',
        name: 'product-raw-material-form-new',
        component: ProductRawMaterialForm
    }, {
        path: '/product/raw-material/view/:id',
        name: 'product-raw-material-form-view',
        component: ProductRawMaterialForm
    }, {
        path: '/product/raw-material/remove/:id',
        name: 'product-raw-material-form-remove',
        component: ProductRawMaterialForm
    }, {
        path: '/product/raw-material/:id',
        name: 'product-raw-material-form',
        component: ProductRawMaterialForm
    }
    , {path: '/product/raw-material', name: 'product-raw-material', component: ProductRawMaterial}
    , {
        path: '/product/type-raw-material/new',
        name: 'product-type-raw-material-form-new',
        component: ProductTypeRawMaterialForm
    }, {
        path: '/product/type-raw-material/view/:id',
        name: 'product-type-raw-material-form-view',
        component: ProductTypeRawMaterialForm
    }, {
        path: '/product/type-raw-material/remove/:id',
        name: 'product-type-raw-material-form-remove',
        component: ProductTypeRawMaterialForm
    }, {
        path: '/product/type-raw-material/:id',
        name: 'product-type-raw-material-form',
        component: ProductTypeRawMaterialForm
    }
    , {path: '/product/type-raw-material', name: 'product-type-raw-material', component: ProductTypeRawMaterial}

    , {
        path: '/product/component/new',
        name: 'product-component-form-new',
        component: ProductComponentForm
    }, {
        path: '/product/component/view/:id',
        name: 'product-component-form-view',
        component: ProductComponentForm
    }, {
        path: '/product/component/remove/:id',
        name: 'product-component-form-remove',
        component: ProductComponentForm
    }, {
        path: '/product/component/:id',
        name: 'product-component-form',
        component: ProductComponentForm
    }
    , {path: '/product/component', name: 'product-component', component: ProductComponent}

    , {
        path: '/product/type-component/new',
        name: 'product-type-component-form-new',
        component: ProductTypeComponentForm
    }, {
        path: '/product/type-component/view/:id',
        name: 'product-type-component-form-view',
        component: ProductTypeComponentForm
    }, {
        path: '/product/type-component/remove/:id',
        name: 'product-type-component-form-remove',
        component: ProductTypeComponentForm
    }, {
        path: '/product/type-component/:id',
        name: 'product-type-component-form',
        component: ProductTypeComponentForm
    }
    , {path: '/product/type-component', name: 'product-type-component', component: ProductTypeComponent}

    , {
        path: '/product/compound/new',
        name: 'product-compound-form-new',
        component: ProductCompoundForm
    }, {
        path: '/product/compound/view/:id',
        name: 'product-compound-form-view',
        component: ProductCompoundForm
    }, {
        path: '/product/compound/remove/:id',
        name: 'product-compound-form-remove',
        component: ProductCompoundForm
    }, {
        path: '/product/compound/:id',
        name: 'product-compound-form',
        component: ProductCompoundForm
    }
    , {path: '/product/compound', name: 'product-compound', component: ProductCompound}

    , {
        path: '/product/type-compound/new',
        name: 'product-type-compound-form-new',
        component: ProductTypeCompoundForm
    }, {
        path: '/product/type-compound/view/:id',
        name: 'product-type-compound-form-view',
        component: ProductTypeCompoundForm
    }, {
        path: '/product/type-compound/remove/:id',
        name: 'product-type-compound-form-remove',
        component: ProductTypeCompoundForm
    }, {
        path: '/product/type-compound/:id',
        name: 'product-type-compound-form',
        component: ProductTypeCompoundForm
    }
    , {path: '/product/type-compound', name: 'product-type-compound', component: ProductTypeCompound}

    , {
        path: '/product/type-material/new',
        name: 'product-type-material-form-new',
        component: ProductTypeMaterialForm
    }, {
        path: '/product/type-material/view/:id',
        name: 'product-type-material-form-view',
        component: ProductTypeMaterialForm
    }, {
        path: '/product/type-material/remove/:id',
        name: 'product-type-material-form-remove',
        component: ProductTypeMaterialForm
    }, {
        path: '/product/type-material/:id',
        name: 'product-type-material-form',
        component: ProductTypeMaterialForm
    }
    , {path: '/product/type-material', name: 'product-type-material', component: ProductTypeMaterial}

    , {
        path: '/product/material/new',
        name: 'product-material-form-new',
        component: ProductMaterialForm
    }, {
        path: '/product/material/view/:id',
        name: 'product-material-form-view',
        component: ProductMaterialForm
    }, {
        path: '/product/material/remove/:id',
        name: 'product-material-form-remove',
        component: ProductMaterialForm
    }, {
        path: '/product/material/:id',
        name: 'product-material-form',
        component: ProductMaterialForm
    }
    , {path: '/product/material', name: 'product-material', component: ProductMaterial}


    , {
        path: '/product/tolerance/new',
        name: 'product-tolerance-form-new',
        component: ProductToleranceForm
    }, {
        path: '/product/tolerance/view/:id',
        name: 'product-tolerance-form-view',
        component: ProductToleranceForm
    }, {
        path: '/product/tolerance/remove/:id',
        name: 'product-tolerance-form-remove',
        component: ProductToleranceForm
    }, {
        path: '/product/tolerance/:id',
        name: 'product-tolerance-form',
        component: ProductToleranceForm
    }
    , {path: '/product/tolerance', name: 'product-tolerance', component: ProductTolerance}


    , {
        path: '/product/feature/new',
        name: 'product-feature-form-new',
        component: ProductFeatureForm
    }, {
        path: '/product/feature/view/:id',
        name: 'product-feature-form-view',
        component: ProductFeatureForm
    }, {
        path: '/product/feature/remove/:id',
        name: 'product-feature-form-remove',
        component: ProductFeatureForm
    }, {
        path: '/product/feature/:id',
        name: 'product-feature-form',
        component: ProductFeatureForm
    }
    , {path: '/product/feature', name: 'product-feature', component: ProductFeature}


    , {
        path: '/product/type-feature/new',
        name: 'product-type-feature-form-new',
        component: ProductTypeFeatureForm
    }, {
        path: '/product/type-feature/view/:id',
        name: 'product-type-feature-form-view',
        component: ProductTypeFeatureForm
    }, {
        path: '/product/type-feature/remove/:id',
        name: 'product-type-feature-form-remove',
        component: ProductTypeFeatureForm
    }, {
        path: '/product/type-feature/:id',
        name: 'product-type-feature-form',
        component: ProductTypeFeatureForm
    }
    , {path: '/product/type-feature', name: 'product-type-feature', component: ProductTypeFeature}

    , {
        path: '/product/complement/new',
        name: 'product-complement-form-new',
        component: ProductComplementForm
    }, {
        path: '/product/complement/view/:id',
        name: 'product-complement-form-view',
        component: ProductComplementForm
    }, {
        path: '/product/complement/remove/:id',
        name: 'product-complement-form-remove',
        component: ProductComplementForm
    }, {
        path: '/product/complement/:id',
        name: 'product-complement-form',
        component: ProductComplementForm
    }
    , {path: '/product/complement', name: 'product-complement', component: ProductComplement}

    , {
        path: '/product/type-building-material/new',
        name: 'product-type-building-material-form-new',
        component: ProductTypeBuildingMaterialForm
    }, {
        path: '/product/type-building-material/view/:id',
        name: 'product-type-building-material-form-view',
        component: ProductTypeBuildingMaterialForm
    }, {
        path: '/product/type-building-material/remove/:id',
        name: 'product-type-building-material-form-remove',
        component: ProductTypeBuildingMaterialForm
    }, {
        path: '/product/type-building-material/:id',
        name: 'product-type-building-material-form',
        component: ProductTypeBuildingMaterialForm
    }
    , {path: '/product/type-building-material', name: 'product-type-building-material', component: ProductTypeBuildingMaterial}

    , {
        path: '/product/type-equipment/new',
        name: 'product-type-equipment-form-new',
        component: ProductTypeEquipmentForm
    }, {
        path: '/product/type-equipment/view/:id',
        name: 'product-type-equipment-form-view',
        component: ProductTypeEquipmentForm
    }, {
        path: '/product/type-equipment/remove/:id',
        name: 'product-type-equipment-form-remove',
        component: ProductTypeEquipmentForm
    }, {
        path: '/product/type-equipment/:id',
        name: 'product-type-equipment-form',
        component: ProductTypeEquipmentForm
    }
    , {path: '/product/type-equipment', name: 'product-type-equipment', component: ProductTypeEquipment}

    , {
        path: '/product/setting/param/view/:id',
        name: 'product-setting-param-form-view',
        component: ProductSettingParamForm
    },
    {
        path: '/product/setting/param/:id',
        name: 'product-setting-param-form-',
        component: ProductSettingParamForm
    }

    , {path: '/product/setting/param', name: 'product-setting-param', component: ProductSettingParam}

    , {path: '/product/setting', name: 'product-setting', component: ProductSetting}

    , {path: '/product/report', name: 'product-report', component: ProductReport}

    , {
        path: '/product/new',
        name: 'product-item-form-new',
        component: ProductProductForm
    }, {
        path: '/product/view/:id',
        name: 'product-item-form-view',
        component: ProductProductForm
    }, {
        path: '/product/remove/:id',
        name: 'product-item-form-remove',
        component: ProductProductForm
    }, {
        path: '/product/:id',
        name: 'product-item-form',
        component: ProductProductForm
    }

    /*PATH CURTO SEMPRE NO FINAL*/
    , {path: '/product', name: 'product-item', component: ProductProduct}

    , {
        path: '/customer/group/new',
        name: 'customer-group-form-new',
        component: CustomerGroupCustomerForm
    }, {
        path: '/customer/group/view/:id',
        name: 'customer-group-form-view',
        component: CustomerGroupCustomerForm
    }, {
        path: '/customer/group/remove/:id',
        name: 'customer-group-form-remove',
        component: CustomerGroupCustomerForm
    }, {
        path: '/customer/group/:id',
        name: 'customer-group-form',
        component: CustomerGroupCustomerForm
    }
    , {path: '/customer/group', name: 'customer-group', component: CustomerGroupCustomer}

    , {
        path: '/customer/type-profile/new',
        name: 'customer-type-profile-form-new',
        component: CustomerTypeProfileForm
    }, {
        path: '/customer/type-profile/view/:id',
        name: 'customer-type-profile-form-view',
        component: CustomerTypeProfileForm
    }, {
        path: '/customer/type-profile/remove/:id',
        name: 'customer-type-profile-form-remove',
        component: CustomerTypeProfileForm
    }, {
        path: '/customer/type-profile/:id',
        name: 'customer-type-profile-form',
        component: CustomerTypeProfileForm
    }
    , {path: '/customer/type-profile', name: 'customer-type-profile', component: CustomerTypeProfile}


    , {
        path: '/customer/type-origin/new',
        name: 'customer-type-origin-form-new',
        component: CustomerTypeOriginForm
    }, {
        path: '/customer/type-origin/view/:id',
        name: 'customer-type-origin-form-view',
        component: CustomerTypeOriginForm
    }, {
        path: '/customer/type-origin/remove/:id',
        name: 'customer-type-origin-form-remove',
        component: CustomerTypeOriginForm
    }, {
        path: '/customer/type-origin/:id',
        name: 'customer-type-origin-form',
        component: CustomerTypeOriginForm
    }
    , {path: '/customer/type-origin', name: 'customer-type-origin', component: CustomerTypeOrigin}




    , {
        path: '/customer/setting/param/view/:id',
        name: 'customer-setting-param-form-view',
        component: CustomerSettingParamForm
    },
    {
        path: '/customer/setting/param/:id',
        name: 'customer-setting-param-form-',
        component: CustomerSettingParamForm
    }

    , {path: '/customer/setting/param', name: 'customer-setting-param', component: CustomerSettingParam}

    , {path: '/customer/setting', name: 'customer-setting', component: CustomerSetting}

    , {path: '/customer/report', name: 'customer-report', component: CustomerReport}


    , {
        path: '/customer/new',
        name: 'customer-item-form-new',
        component: CustomerCustomerForm
    }, {
        path: '/customer/view/:id',
        name: 'customer-item-form-view',
        component: CustomerCustomerForm
    }, {
        path: '/customer/remove/:id',
        name: 'customer-item-form-remove',
        component: CustomerCustomerForm
    }, {
        path: '/customer/:id',
        name: 'customer-item-form',
        component: CustomerCustomerForm
    }

    /*PATH CURTO SEMPRE NO FINAL*/
    , {path: '/customer', name: 'customer-item', component: CustomerCustomer}


    , {
        path: '/stock/place-product/new',
        name: 'stock-place-product-form-new',
        component: StockPlaceProductForm
    }, {
        path: '/stock/place-product/view/:id',
        name: 'stock-place-product-form-view',
        component: StockPlaceProductForm
    }, {
        path: '/stock/place-product/remove/:id',
        name: 'stock-place-product-form-remove',
        component: StockPlaceProductForm
    }, {
        path: '/stock/place-product/:id',
        name: 'stock-place-product-form',
        component: StockPlaceProductForm
    }
    , {path: '/stock/place-product', name: 'stock-place-product', component: StockPlaceProduct}

    , {
        path: '/stock/place-mold/new',
        name: 'stock-place-mold-form-new',
        component: StockPlaceMoldForm
    }, {
        path: '/stock/place-mold/view/:id',
        name: 'stock-place-mold-form-view',
        component: StockPlaceMoldForm
    }, {
        path: '/stock/place-mold/remove/:id',
        name: 'stock-place-mold-form-remove',
        component: StockPlaceMoldForm
    }, {
        path: '/stock/place-mold/:id',
        name: 'stock-place-mold-form',
        component: StockPlaceMoldForm
    }
    , {path: '/stock/place-mold', name: 'stock-place-mold', component: StockPlaceMold}

    , {
        path: '/stock/type-expedition-status/new',
        name: 'stock-type-expedition-status-form-new',
        component: StockTypeStatusExpeditionForm
    }, {
        path: '/stock/type-expedition-status/view/:id',
        name: 'stock-type-expedition-status-form-view',
        component: StockTypeStatusExpeditionForm
    }, {
        path: '/stock/type-expedition-status/remove/:id',
        name: 'stock-type-expedition-status-form-remove',
        component: StockTypeStatusExpeditionForm
    }, {
        path: '/stock/type-expedition-status/:id',
        name: 'stock-type-expedition-status-form',
        component: StockTypeStatusExpeditionForm
    }
    , {
        path: '/stock/type-expedition-status',
        name: 'stock-type-expedition-status',
        component: StockTypeStatusExpedition
    }, {
        path: '/stock/expedition-order/new',
        name: 'stock-expedition-order-form-new',
        component: StockExpeditionOrderForm
    }, {
        path: '/stock/expedition-order/view/:id',
        name: 'stock-expedition-order-form-view',
        component: StockExpeditionOrderForm
    }, {
        path: '/stock/expedition-order/remove/:id',
        name: 'stock-expedition-order-form-remove',
        component: StockExpeditionOrderForm
    }, {
        path: '/stock/expedition-order/:id',
        name: 'stock-expedition-order-form',
        component: StockExpeditionOrderForm
    }
    , {path: '/stock/expedition-order', name: 'stock-expedition-order', component: StockExpeditionOrder}

    , {
        path: '/stock/type-manual/new',
        name: 'stock-type-manual-form-new',
        component: StockTypeStockManualForm
    }, {
        path: '/stock/type-manual/view/:id',
        name: 'stock-type-manual-form-view',
        component: StockTypeStockManualForm
    }, {
        path: '/stock/type-manual/remove/:id',
        name: 'stock-type-manual-form-remove',
        component: StockTypeStockManualForm
    }, {
        path: '/stock/type-manual/:id',
        name: 'stock-type-manual-form',
        component: StockTypeStockManualForm
    }
    , {path: '/stock/type-manual', name: 'stock-type-manual', component: StockTypeStockManual}

    , {
        path: '/stock/setting/param/view/:id',
        name: 'stock-setting-param-form-view',
        component: StockSettingParamForm
    },
    {
        path: '/stock/setting/param/:id',
        name: 'stock-setting-param-form-',
        component: StockSettingParamForm
    }

    , {path: '/stock/setting/param', name: 'stock-setting-param', component: StockSettingParam}

    , {path: '/stock/setting', name: 'stock-setting', component: StockSetting}

    , {path: '/stock/report', name: 'stock-report', component: StockReport}


    , {
        path: '/stock/product/manual',
        name: 'stock-product-form-new',
        component: StockProductManualForm
    }
    /*PATH CURTO SEMPRE NO FINAL*/
    , {path: '/stock/product-in-out', name: 'stock-product-in-out', component: StockProductInOut}
    , {path: '/stock/product', name: 'stock-product', component: StockProduct}

    , {
        path: '/admin/company/new',
        name: 'admin-company-form-new',
        component: AdminCompanyForm
    }, {
        path: '/admin/company/view/:id',
        name: 'admin-company-form-view',
        component: AdminCompanyForm
    }, {
        path: '/admin/company/remove/:id',
        name: 'admin-company-form-remove',
        component: AdminCompanyForm
    }, {
        path: '/admin/company/:id',
        name: 'admin-company-form',
        component: AdminCompanyForm
    }
    , {path: '/admin/company', name: 'admin-company', component: AdminCompany}


    , {
        path: '/admin/user/new',
        name: 'admin-user-form-new',
        component: AdminUserForm
    }, {
        path: '/admin/user/view/:id',
        name: 'admin-user-form-view',
        component: AdminUserForm
    }, {
        path: '/admin/user/remove/:id',
        name: 'admin-user-form-remove',
        component: AdminUserForm
    }, {
        path: '/admin/user/:id',
        name: 'admin-user-form',
        component: AdminUserForm
    }
    , {path: '/admin/user', name: 'admin-user', component: AdminUser}

    , {
        path: '/admin/department/new',
        name: 'admin-department-form-new',
        component: AdminDepartmentForm
    }, {
        path: '/admin/department/view/:id',
        name: 'admin-department-form-view',
        component: AdminDepartmentForm
    }, {
        path: '/admin/department/remove/:id',
        name: 'admin-department-form-remove',
        component: AdminDepartmentForm
    }, {
        path: '/admin/department/:id',
        name: 'admin-department-form',
        component: AdminDepartmentForm
    }
    , {path: '/admin/department', name: 'admin-department', component: AdminDepartment}

    , {
        path: '/admin/group-user/new',
        name: 'admin-group-user-form-new',
        component: AdminGroupUserForm
    }, {
        path: '/admin/group-user/view/:id',
        name: 'admin-group-user-form-view',
        component: AdminGroupUserForm
    }, {
        path: '/admin/group-user/remove/:id',
        name: 'admin-group-user-form-remove',
        component: AdminGroupUserForm
    }, {
        path: '/admin/group-user/:id',
        name: 'admin-group-user-form',
        component: AdminGroupUserForm
    }
    , {path: '/admin/group-user', name: 'admin-group-user', component: AdminGroupUser}

    , {
        path: '/admin/profile/new',
        name: 'admin-profile-form-new',
        component: AdminProfileForm
    }, {
        path: '/admin/profile/view/:id',
        name: 'admin-profile-form-view',
        component: AdminProfileForm
    }, {
        path: '/admin/profile/remove/:id',
        name: 'admin-profile-form-remove',
        component: AdminProfileForm
    }, {
        path: '/admin/profile/:id',
        name: 'admin-profile-form',
        component: AdminProfileForm
    }
    , {path: '/admin/profile', name: 'admin-profile', component: AdminProfile}

    , {
        path: '/admin/printer/new',
        name: 'admin-printer-form-new',
        component: AdminPrinterForm
    }, {
        path: '/admin/printer/view/:id',
        name: 'admin-printer-form-view',
        component: AdminPrinterForm
    }, {
        path: '/admin/printer/remove/:id',
        name: 'admin-printer-form-remove',
        component: AdminPrinterForm
    }, {
        path: '/admin/printer/:id',
        name: 'admin-printer-form',
        component: AdminPrinterForm
    }
    , {path: '/admin/printer', name: 'admin-printer', component: AdminPrinter}





    , {
        path: '/admin/access-control/new',
        name: 'admin-access-control-form-new',
        component: AdminAccessControlForm
    }, {
        path: '/admin/access-control/view/:id',
        name: 'admin-access-control-form-view',
        component: AdminAccessControlForm
    }, {
        path: '/admin/access-control/remove/:id',
        name: 'admin-access-control-form-remove',
        component: AdminAccessControlForm
    }, {
        path: '/admin/access-control/:id',
        name: 'admin-access-control-form',
        component: AdminAccessControlForm
    }
    , {path: '/admin/access-control', name: 'admin-access-control', component: AdminAccessControl},

    {
        path: '/admin/setting/param/view/:id',
        name: 'admin-setting-param-form-view',
        component: AdminSettingParamForm
    },
    {
        path: '/admin/setting/param/:id',
        name: 'admin-setting-param-form-',
        component: AdminSettingParamForm
    }

    , {path: '/admin/setting/param', name: 'admin-setting-param', component: AdminSettingParam}

    , {path: '/admin/setting', name: 'admin-setting', component: AdminSetting}

]